import {AdminOperationalPage,type AdminPageConnection,type AdminPageSpec} from "@shifath/platform-admin-core";
export function RepairsPage({spec,connection}:{spec:AdminPageSpec;connection:AdminPageConnection}){return <AdminOperationalPage spec={spec} connection={connection}/>}
